<template>
  <div class="login">
    <img src="../assets/img/login-logo.png" alt="" class="login-logo">
    <div class="flex align-start justify-between bx-content">
      <img src="../assets/img/login-text.png" alt="" class="login-text">
      <div class="login-form">
        <slot name="login"></slot>
        <slot name="register"></slot>
        <slot name="forget"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "login-modular",
  data() {
    return {}
  },
  created() {
  },
  components: {},
  methods: {},
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.login{
  width: 100%;
  height: 646px;
  padding: 30px 0;
  background: url(../assets/img/login-bg.jpg) no-repeat center;
  .login-logo{
    display: block;
    margin: 0 auto 20px;
  }
  .login-form{
    background: #fff;
    padding: 30px;
    width: 402px;
    max-height: 480px;
    border-radius: 5px;
  }
  .login-text{
    position: relative;
    top: 100px;
  }
}
</style>